// Central store using Vue 2 reactive system
import Vue from 'vue';
import { sessionStore } from './sessionStore';
import { transcriptStore } from './transcriptStore';
import { websocketStore } from './websocketStore';
import { gemsStore } from './gemsStore';
import { organizationStore } from './organizationStore';
// UI-specific store
class UIStore {
    state = Vue.observable({
        sidebarOpen: false,
        darkMode: false,
        notifications: [],
        loading: false
    });
    // Getters
    get sidebarOpen() {
        return this.state.sidebarOpen;
    }
    get darkMode() {
        return this.state.darkMode;
    }
    get notifications() {
        return this.state.notifications;
    }
    get loading() {
        return this.state.loading;
    }
    // Actions
    setSidebarOpen(open) {
        this.state.sidebarOpen = open;
    }
    setDarkMode(enabled) {
        this.state.darkMode = enabled;
    }
    setLoading(loading) {
        this.state.loading = loading;
    }
    addNotification(notification) {
        this.state.notifications.push(notification);
    }
    removeNotification(id) {
        const index = this.state.notifications.findIndex(n => n.id === id);
        if (index > -1) {
            this.state.notifications.splice(index, 1);
        }
    }
    clearNotifications() {
        this.state.notifications = [];
    }
}
// Main store that coordinates all modules
class RootStore {
    session = sessionStore;
    transcript = transcriptStore;
    websocket = websocketStore;
    gems = gemsStore;
    organization = organizationStore;
    ui = new UIStore();
    // Global actions that affect multiple stores
    clearAll() {
        this.session.clearAll();
        this.transcript.clearAll();
        this.websocket.clearAll();
        this.gems.clearAll();
        this.organization.clearAll();
        this.ui.clearNotifications();
    }
    // Session-related composite actions
    async loadSession(sessionId) {
        console.log(`Loading session: ${sessionId}`);
        this.session.setLoading(true);
        this.transcript.clearTranscripts();
        try {
            // This will be replaced with actual service call in Phase 4
            // For now, just clear loading state
            this.session.setLoading(false);
        }
        catch (error) {
            this.session.setError(error.message);
            this.session.setLoading(false);
        }
    }
    setCurrentSessionWithTranscripts(session) {
        this.session.setCurrentSession(session);
        this.transcript.setTranscripts(session.transcripts || []);
        this.transcript.setTimedTranscripts(session.timedTranscripts || []);
    }
}
// Export singleton instance
export const store = new RootStore();
// Helper function to use store in components
export function useStore() {
    return store;
}
